export enum BLCTypeEnum {
    Bond = 0,
    LetterOfCredit = 1
}
